<template>
  <div
      class="order-return-review-customer-details flex flex-auto flex-col">
    <div class="title">
      Customer Details
    </div>
    <div style="margin-top: 24px">
      <div class="section-header">
        <div class="flex-1">
          Customer Details
        </div>
        <a
            class="edit-details-link"
            @click="$emit('update:editDetails', true)">
          Edit Customer Details
        </a>
      </div>
    </div>
    <div class="return-customer-details">
      <el-card shadow="never">
        <div class="flex flex-col">
          <div class="flex flex-row">
            <div class="flex-1">
              Name
            </div>
            <div>{{ customer.customer_name }}</div>
          </div>
          <div class="flex flex-row">
            <div class="flex-1">
              Phone Number
            </div>
            <div>{{ customer.customer_phone }}</div>
          </div>
          <div class="flex flex-row">
            <div class="flex-1">
              Email
            </div>
            <div>{{ customer.customer_email }}</div>
          </div>
          <div
              class="flex flex-row"
              style="margin-top: 20px">
            <div class="flex-1">
              Street
            </div>
            <div>{{ address.address_1 }} {{ address.address_2 }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              City
            </div>
            <div>{{ address.city }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              State/province/area
            </div>
            <div>{{ address.state }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              Zip code
            </div>
            <div>{{ address.zip }}</div>
          </div>
          <div
              class="flex flex-row">
            <div class="flex-1">
              Country
            </div>
            <div>{{ address.country }}</div>
          </div>
        </div>
      </el-card>
    </div>
    <div style="margin-top: 16px">
      <div
          class="section-header">
        Payment
      </div>
    </div>
    <div class="return-customer-details">
      <el-card shadow="never">
        <div class="flex flex-col">
          <div class="flex flex-row">
            <div class="flex-1">
              State Tax
            </div>
            <div>{{ formattedAmount(totalTax.amount, totalTax.currency_code) }}</div>
          </div>
          <div class="flex flex-row">
            <div class="flex-1">
              Additional fees
            </div>
            <div>{{ formattedAmount(additionalFees, totalTax.currency_code) }}</div>
          </div>
          <el-divider />
          <div class="flex flex-row">
            <div class="flex-1">
              Total refund
            </div>
            <div>{{ formattedAmount(refundInfo.amount, refundInfo.currency) }}</div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import numeral from "numeral";
import axios from "axios";

export default {
  name: "ReviewCustomerDetails",
  props: {
    customer: {
      type: Object,
      required: true,
      default() {
        return {
          customer_email: "",
          customer_name: "",
          customer_phone: "",
        };
      },
    },
    address: {
      type: Object,
      required: true,
      default() {
        return {
          address_1: "",
          address_2: "",
          city: "",
          country: "",
          state: "",
          zip: "",
        };
      },
    },
    refundPaymentInfo: {
      type: Object,
      required: true,
      default() {
        return {
          stateTax: 0,
          additionalFees: 0,
          totalRefund: 0,
          currency: "USD",
        };
      },
    },
    refundInfo: {
      type: Object,
      required: true,
      default() {
        return {
          amount: 200,
          currency: "USD",
          line_items: [],
        };
      },
    },
    additionalFees: {
      type: Number,
      required: false,
      default: 0,
    },
    totalTax: {
      type: Object,
      required: true,
      default() {
        return {
          amount: 0,
          currency_code: "USD",
        };
      },
    },
  },
  data() {
    return {
      currencySymbols: {
        EUR: "€",
        NONE: "",
        USD: "$",
        GBP: "£",
        AUD: "A$",
        NZD: "N$",
        CAD: "C$",
      },
    };
  },
  mounted() {},
  methods: {
    formattedAmount(amount, currency) {
      var neg = false;
      if (amount < 0) {
        neg = true;
        amount = -amount;
      }

      amount = numeral(amount).format(`0,0.00`);
      return `${neg ? "– " : ""}${
        this.currencySymbols[currency || "USD"]
      }${amount}`;
    },
  },
};
</script>

<style>
.order-return-review-customer-details {
  gap: 8px;

  .title {
    height: 36px;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 36px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .description {
    height: 24px;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #424242;
    flex: none;
    align-self: stretch;
    flex-grow: 0;
  }

  .section-header {
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    display: flex;
    align-items: flex-end;
    color: #6e6e6e;
    flex: none;
    flex-grow: 1;
  }

  .return-customer-details {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #424242;
  }

  .edit-details-link {
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    text-decoration-line: underline;
    color: #1476ad;
  }
}
</style>
